/* eslint-disable security/detect-object-injection */
/* eslint-disable consistent-return */
/* eslint-disable no-secrets/no-secrets */
import { GatewayFNOLService as FNOLService } from 'twia-capability-gateway-fnol';
import { useTranslator } from '@jutro/locale';
import { withAuthenticationContext, useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import {
    useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { WizardPageTemplate } from 'gw-portals-wizard-components-ui';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import FNOLCriminalDamage from '../../components/CriminalDamage/CriminalDamage';
import WaterComponent from '../../components/WaterComponent/WaterComponent';
import FNOLFireDetails from '../../components/FireDetails/FireDetails';
import FNOLLiabilityDetails from '../../components/Liability/Liability';
import messages from '../../FNOL.messages';
import LossDamageUtil from '../../utils/LossDamageUtil';
import metadata from './AdditionalLossdetailsPage.metadata.json5';
import styles from './AdditionalLossdetailsPage.module.scss';

function FNOLAdditionalLossdetailsPage(props) {
    const { wizardData: claimVM, updateWizardData, authHeader } = props;
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { onValidate, isComponentValid, registerComponentValidation } = useValidation('FNOLAdditionalLossdetailsPage');
    const [lossDamageList, updateLossDamageList] = useState();
    const [lossDamagesLoc, setLossDamagesLoc] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const { refreshData } = useDataRefresh();
    const policyTypelist = viewModelService.productMetadata.get('cc').types.getTypelist('PolicyType')
    const policyType = _.get(claimVM, 'policy.policyType.value'); // DE17006
    const commercialPolicyType = policyTypelist.getFilter('PolicyTypes_TWIAPC9Commercial').codes.find(code => code.code === policyType);
    const isCommercial = !_.isUndefined(commercialPolicyType) || policyType === 'CommercialProperty';
    const isResidential = ['ManufacturedProperty', 'ResidentialProperty', 'Homeowners'].includes(policyType);
    const propertyWater = _.get(claimVM, 'lobs.homeowners.propertyWaterDamage')
    const isTheftOrVandalism = ['burglary', 'vandalism'].includes(_.get(claimVM.value, 'lossCause'));
    const waterDamageSelected = ['waterdamage'].includes(_.get(claimVM.value, 'lossCause'));
    const isWindandHail = ['bothExt', 'wind', 'hail'].includes(_.get(claimVM.value, 'lossCause'))
    const isHomeowners = !isCommercial;
    const isFireDamage = _.get(claimVM.value, 'lossCause') === 'fire';
    const isLiability = _.get(claimVM.value, 'lossCause') === 'liability_TFPA';
    const vmDTO = useCallback((data) => viewModelService.create(data || {}, 'cc', 'ext.TWIA.edge.capabilities.claim.dto.LossDamageExtDTO'), [viewModelService]);
    const { authUserData } = useAuthentication();
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
    const [isLiabOverlayVisible, setLiabOverlayVisible] = useState(false); 

    const hasPersonalPropertyCoverage = useMemo(() => {
        const locationBasedRisks = _.get(claimVM, 'lossDamagesExt.value')
        const locationBasedRisksExt = locationBasedRisks && locationBasedRisks.length > 0
            ? locationBasedRisks[0] : false

        if (locationBasedRisksExt) {
            const matchingCoverages = locationBasedRisksExt.locationBasedRU.coverages.filter((coverage) => [
                'CPCovBBPP',
                'CPPersonalPropertyCovBExt',
                'CPOffPremisPropertyCovBExt',
                'CPPersonalPropertyCovBExt',
                'CPPPropertyCovBExt',
                'CPBPPCov'
            ].indexOf(coverage.coverageTypeExt) !== -1)

            return matchingCoverages.length > 0
        }

        return false;
    }, [claimVM]);

    const hasStructureCoverage = useMemo(() => {
        const locationBasedRisks = _.get(claimVM, 'lossDamagesExt.value')
        const locationBasedRisksExt = locationBasedRisks && locationBasedRisks.length > 0
            ? locationBasedRisks[0] : false

        if (locationBasedRisksExt) {
            const matchingCoverages = locationBasedRisksExt.locationBasedRU.coverages.filter((coverage) => [
                'MHCoverageA',
                'CPStructureCovExt',
                'CPBldgCov',
                'zqsgcojpi7hde91ug594bs26jp8'
            ].indexOf(coverage.coverageTypeExt) !== -1)

            return matchingCoverages.length > 0
        }

        return false

    }, [claimVM]);


    const lossDamagesExtVM = useCallback((data) => {
        const update = viewModelService.create(data ||
            {},
            'cc',
            'ext.TWIA.edge.capabilities.claim.dto.LossDamageExtDTO'
        );

        updateLossDamageList(update);

    }, [viewModelService, updateLossDamageList]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(claimVM, path, value);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const propertyWaterDamageData = useCallback(() => {
        _.set(claimVM, 'lobs.homeowners', {})
        _.set(claimVM, 'lobs.homeowners.propertyWaterDamage', {})
        _.set(claimVM, 'lobs.homeowners.propertyFireDamage', {})
        _.set(claimVM, 'lobs.homeowners.propTheftVanDamageDTO_TFPA', {})

    }, [claimVM]);

    useEffect(() => {
        lossDamagesExtVM(claimVM.lossDamagesExt.value);
    }, [lossDamagesExtVM, claimVM]);

    useEffect(() => {
        if (isTFPA) {
            if (isTheftOrVandalism && _.isUndefined(_.get(claimVM.value, 'lobs.homeowners.propTheftVanDamageDTO_TFPA'))) {
                _.set(claimVM, 'lobs.homeowners', {});
                _.set(claimVM, 'lobs.homeowners.propTheftVanDamageDTO_TFPA', {});
            } else if (waterDamageSelected && _.isUndefined(propertyWater?.value)) {
                propertyWaterDamageData();
            } else if (isFireDamage && _.isUndefined(_.get(claimVM.value, 'lobs.homeowners.propertyFireDamage'))) {
                _.set(claimVM, 'lobs.homeowners', {});
                _.set(claimVM, 'lobs.homeowners.propertyFireDamage', {});
            }
        }
    }, [claimVM, isFireDamage, isTFPA, isTheftOrVandalism, propertyWaterDamageData, waterDamageSelected]);

    const getLabels = useCallback((id) => {
        if (id === 'extraDamageID') {
            if (isCommercial) {
                return translator(messages.extraCommercialDamage)
            }

            return translator(messages.extraDamage)

        }

        if (id === 'interiorDamageID') {
            if (isCommercial) {
                return translator(messages.interiorCommericalDamage)
            }

            return translator(messages.interiorDamage)

        }

        if (id === 'personalDamageID') {
            if (isCommercial) {
                return translator(messages.commericalDamage)
            }

            return translator(messages.personalDamage)

        }

        if (id === 'unavailableDamageID') {
            if (isCommercial) {
                return translator(messages.homeUnavailableCommercial)
            }

            return translator(messages.homeUnavailable)

        }

    }, [isCommercial, translator]);


    const overrides = {
        extraDamageID: {
            label: getLabels('extraDamageID'),
            value: _.get(claimVM, 'lossDamagesExt.value[0]') && claimVM.lossDamagesExt.value.length > 0 // DE16559
                ? claimVM.lossDamagesExt.value[0].exteriorDamage
                : null,
            visible: hasStructureCoverage || (isHomeowners)
        },
        interiorDamageID: {
            label: getLabels('interiorDamageID'),
            visible: hasStructureCoverage || (isHomeowners)
        },
        personalDamageID: {
            label: getLabels('personalDamageID'),
            visible: (hasPersonalPropertyCoverage && (isCommercial || isResidential)) || (isHomeowners)
        },
        unavailableDamageID: {
            label: getLabels('unavailableDamageID'),
            visible: ((hasStructureCoverage || hasPersonalPropertyCoverage) && isResidential) || (isHomeowners)
        },
        businessOptSuspendedID: {
            visible: (hasStructureCoverage || hasPersonalPropertyCoverage) && isCommercial
        },
        emergenceServicesID: {
            visible: isCommercial
        },
        additionalInfoContainer: {
            visible: !(['burglary', 'vandalism', 'fire', 'waterdamage', 'liability_TFPA'].includes(_.get(claimVM.value, 'lossCause')))
        },
        fnolCriminalDamageContainer: {
            criminalDamageData: claimVM,
            visible: isTFPA && isTheftOrVandalism,
            updateWizardData,
            showErrors,
            onValidate
        },
        WaterComponent: {
            wizardData: claimVM,
            visible: isTFPA && ['waterdamage'].includes(_.get(claimVM.value, 'lossCause')),
            updateWizardData,
            showErrors,
            onValidate
        },
        fireDetailsContainer: {
            fireDetailsData: claimVM,
            visible: isTFPA && isFireDamage,
            updateWizardData,
            showErrors,
            onValidate
        },
        liabilityDetailsContainer: {
            liabilityDetailsData: claimVM,
            visible: isTFPA && isLiability,
            updateWizardData,
            showErrors,
            onValidate,
            setLiabOverlayVisible
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
        },
        resolveComponentMap: {
            fnolCriminalDamageComponent: FNOLCriminalDamage,
            WaterComponent,
            fnolFireDetailsComponent: FNOLFireDetails,
            fnolLiabilityDetailsComponent: FNOLLiabilityDetails
        }
    };

    const isValidFireDetailsForm = useCallback(() => {
        const fireDetails = _.get(claimVM, 'lobs.homeowners.propertyFireDamage', {});
        const officialReport = _.get(claimVM, 'officialReport_TFPA');
        const isFireDeptResponded = _.get(fireDetails, 'fireDeptResponded_TFPA.value');

        if (isFireDeptResponded === false) {
            return fireDetails?.aspects?.valid && fireDetails?.aspects?.subtreeValid;
        }

        if (isFireDeptResponded === true) {
            return fireDetails?.aspects?.valid && fireDetails?.aspects?.subtreeValid
                && officialReport?.aspects?.valid && officialReport?.aspects?.subtreeValid;
        }
    }, [claimVM]);

    const isValidTheftVanDamageForm = useCallback(() => {
        const theftVanDamage = _.get(claimVM, 'lobs.homeowners.propTheftVanDamageDTO_TFPA', {});
        const officialReport = _.get(claimVM, 'officialReport_TFPA');
        const isPoliceReportFiled = _.get(theftVanDamage, 'isPoliceReportFiled.value');

        if (isPoliceReportFiled === false) {
            return theftVanDamage?.aspects?.valid && theftVanDamage?.aspects?.subtreeValid;
        }

        if (isPoliceReportFiled === true) {
            return theftVanDamage?.aspects?.valid && theftVanDamage?.aspects?.subtreeValid
                && officialReport?.aspects?.valid && officialReport?.aspects?.subtreeValid;
        }
    }, [claimVM]);

    const isValidWaterDamageForm = useCallback(() => {
        const propertWaterDamage = _.get(claimVM, 'lobs.homeowners.propertyWaterDamage');
        const waterSource = _.get(claimVM, 'lobs.homeowners.propertyWaterDamage.waterSource.value');
        const roofProtected = _.get(claimVM, 'lobs.homeowners.propertyWaterDamage.isRoofProtected.value');
        const waterTurnedOff = _.get(claimVM, 'lobs.homeowners.propertyWaterDamage.hasWaterBeenTurnedOff.value');
        let result = true

        if (_.isUndefined(waterSource) || _.isUndefined(roofProtected)
            || _.isUndefined(waterTurnedOff)) {
            result = false
        }
        else {
            result = true
        }

        return propertWaterDamage?.aspects?.valid && propertWaterDamage?.aspects?.subtreeValid && result
    }, [claimVM]);

    // DE17160
    const convertToUTCdate = useCallback((d) => {
        const utcDate = new Date(d.getUTCFullYear(), d.getUTCMonth(),
            d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(),
            d.getUTCMilliseconds());

        return new Date(utcDate.setMinutes(1)).toISOString();
    }, []);

    // DE16704
    const disableNextButton = useCallback(() => {
        const extHome = _.get(claimVM, 'lossDamagesExt.value[0].exteriorDamage');
        const intHome = _.get(claimVM, 'lossDamagesExt.value[0].interiorDamage');
        const personalDamage = _.get(claimVM, 'lossDamagesExt.value[0].personalPropertyDamage');
        let result = true

        if (isTFPA) {
            if (isTheftOrVandalism) {
                return !isValidTheftVanDamageForm();
            }

            if (waterDamageSelected) {
                return !isValidWaterDamageForm();
            }

            if (isFireDamage) {
                return !isValidFireDetailsForm();
            }
        }

        if ((extHome || intHome || personalDamage)) {
            result = false
        }
        else {
            result = true
        }

        return result
    }, [claimVM, isFireDamage, isTFPA, isTheftOrVandalism, isValidFireDetailsForm, isValidTheftVanDamageForm, isValidWaterDamageForm, waterDamageSelected])

    const onNext = useCallback(async () => {
        const claimNumber = _.get(claimVM, 'claimNumber.value');
        const lossItemDetailsList = _.get(claimVM, 'lossDamagesExt.value[0]');
        const leakFoundValue = _.get(claimVM, 'lobs.homeowners.propertyWaterDamage.whenWasLeakFound_TFPA.value');

        if (isTFPA) {
            if (!_.isUndefined(leakFoundValue)) {
                const convertedLossDate = convertToUTCdate(new Date(leakFoundValue));

                _.set(claimVM, 'lobs.homeowners.propertyWaterDamage.whenWasLeakFound_TFPA.value', convertedLossDate);
            }

            if (isTheftOrVandalism && !isValidTheftVanDamageForm()) {
                setShowErrors(true);

                return false;
            }

            if (waterDamageSelected && !isValidWaterDamageForm()) {
                setShowErrors(true);

                return false;
            }

            if (isFireDamage && !isValidFireDetailsForm()) {
                setShowErrors(true);

                return false;
            }

            if (!isWindandHail) {
                setShowErrors(false);

                return claimVM;
            }
        }

        if (isCommercial) {
            const locationBasedRisksExt = _.get(claimVM, 'lossDamagesExt.value')
            const lossDamageData = []

            locationBasedRisksExt.forEach(element => {
                lossDamageData.push(element.locationBasedRU)
            })


            // eslint-disable-next-line guard-for-in
            for (const riskIdx in lossDamageData) {
                const locationBasedRisk = lossDamageData[riskIdx];

                if (locationBasedRisk.selected) {
                    if (lossDamagesLoc.indexOf(locationBasedRisk.publicID) === -1) {
                        lossDamagesLoc.push(locationBasedRisk.publicID);

                        setLossDamagesLoc(lossDamagesLoc);
                    }
                }
            }

            FNOLService.getLossDamagesExtDTO(claimNumber, lossDamagesLoc, authHeader).then(response => {
                const isAdditional = true
                let newLossDamage

                LossDamageUtil.getLossDamageCommercial(vmDTO, response, isCommercial, claimVM, updateWizardData, newLossDamage, refreshData, isAdditional);

                FNOLService.createOrUpdateLossDamagesExt(claimNumber, claimVM.lossDamagesExt.value, authHeader).then(result => {
                    _.set(claimVM, 'lossDamagesExt.value', result);
                    updateWizardData(claimVM);

                    return claimVM;

                }).catch(() => claimVM);


            }).catch(() => claimVM);

        }

        if (!isCommercial) {
            if (claimVM?.lossDamagesExt?.publicID?.value === 0) {
                try {
                    const response = await FNOLService.updateClaimLossDamageExt(claimNumber, lossItemDetailsList, authHeader);

                    _.set(claimVM, 'lossDamagesExt.value[0]', response);
                    updateWizardData(claimVM);
                    refreshData();
                    return claimVM;
                } catch (error) {
                    return claimVM;
                }
            } else {
                try {
                    const response = await FNOLService.createClaimLossDamageExt(claimNumber, lossItemDetailsList, authHeader);

                    _.set(claimVM, 'lossDamagesExt.value[0]', response);
                    updateWizardData(claimVM);
                    refreshData();
                    return claimVM;
                } catch (error) {
                    return claimVM;
                }
            }
        }

        return claimVM;
    }, [claimVM, isTFPA, isCommercial, isTheftOrVandalism, isValidTheftVanDamageForm, waterDamageSelected, isValidWaterDamageForm, isFireDamage, isValidFireDetailsForm, lossDamagesLoc, authHeader, vmDTO, updateWizardData, refreshData]);

    const checkComponentValidation = useCallback(() => !disableNextButton(), [disableNextButton]);

    useEffect(() => {
        registerComponentValidation(checkComponentValidation);
    }, [checkComponentValidation, registerComponentValidation]);

    const disableNextBtn = () => {
        if (isTFPA && isLiability) {
            return !_.get(claimVM, 'incidents.value', []).length || isLiabOverlayVisible;
        } else if (isTFPA && !isWindandHail) {
            return false;
        } else {
            return !isComponentValid;
        }
    }

    return (
        <WizardPage
            onNext={onNext}
            disableNext={disableNextBtn()}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                onValueChange={writeValue}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

FNOLAdditionalLossdetailsPage.propTypes = wizardProps;
export default withRouter(
    withAuthenticationContext(FNOLAdditionalLossdetailsPage)
);
